"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.frLoc = exports.itLoc = exports.deLoc = exports.esLoc = exports.enLoc = void 0;
var de_json_1 = __importDefault(require("./locales/de.json"));
var en_json_1 = __importDefault(require("./locales/en.json"));
var es_json_1 = __importDefault(require("./locales/es.json"));
var fr_json_1 = __importDefault(require("./locales/fr.json"));
var it_json_1 = __importDefault(require("./locales/it.json"));
__exportStar(require("./Article"), exports);
__exportStar(require("./autopricing"), exports);
__exportStar(require("./Card"), exports);
__exportStar(require("./constants"), exports);
__exportStar(require("./gameMetaData"), exports);
__exportStar(require("./lib"), exports);
__exportStar(require("./publishing"), exports);
__exportStar(require("./test"), exports);
__exportStar(require("./types"), exports);
exports.enLoc = en_json_1.default;
exports.esLoc = es_json_1.default;
exports.deLoc = de_json_1.default;
exports.itLoc = it_json_1.default;
exports.frLoc = fr_json_1.default;
//# sourceMappingURL=index.js.map